const smartzEventConst = {
  analysing: 'ANALYSING',
  padRemoved: 'DISCONNECTED',
  external: 'WETSURFACE',
  outOfRange: 'OUTOFRANGE',
  lowBattery: 'LOWBATTERY',
  timeToChange: 'PAD_CHANGE_ALERT', // deprecated
  fall: 'FALL_DETECTED_ALERT',
  reposition: 'POSITION_CHANGE_ALERT',
  temperature: 'TEMPERATURE_CHECK_ALERT',
  green: 'GREEN',
  yellow: 'YELLOW',
  red: 'RED',
  diaperNotSelected: 'PADNOTSELECTED',
  goalTimeExceed: 'PAD_CHECK_ALERT_GOAL',
  allowedTimeExceed: 'PAD_CHECK_ALERT_ALLOWED',
  safeTimeExceed: 'PAD_CHECK_ALERT_SAFE',
  diaperNotUsed: 'PADUNKNOWN',
  newBattery: 'NEWBATTERY',
  leakage: 'LEAKAGE',
  unstable: 'UNSTABLE',
  doubleTap: 'DOUBLETAP',
  clumped: 'CLUMPED',
  predictedRed: 'PAD_CHECK_ALERT_RED',
  clumpedGreen: 'CLUMPED-GREEN',
  clumpedYellow: 'CLUMPED-YELLOW',
  checkBin: 'POD-IN-BIN',
  sensorDisconnected: 'SENSORDISCONNECTED',
  checkConnection: 'CHECKCONNECTION',
  padCheckAlertWet: 'PAD_CHECK_ALERT_WET'
}

const voidConst = {
  external: 'WETSURFACE',
  unstable: 'UNSTABLE',
  clumped: 'CLUMPED',
  outOfRange: 'OUTOFRANGE',
  small: 'SMALL',
  medium: 'MEDIUM',
  large: 'LARGE',
  diaperNotSelected: 'PADNOTSELECTED',
  padStart: 'PADSTART',
  padEndLevel1: 'PADENDLEVEL0',
  padEndLevel2: 'PADENDLEVEL25',
  padEndLevel3: 'PADENDLEVEL50',
  padEndLevel4: 'PADENDLEVEL75',
  padEndLevel5: 'PADENDLEVEL100',
  red: 'RED'
}

const padCycleStartType = {
  notStart: 0,
  isStart: 1
}

const padCycleEndType = {
  notCompleted: 0,
  isCompletedImmediate: 1,
  isCompleted: 2
}

const bladderEventType = {
  void: 'VOIDING',
  assessment: 'ASSESSMENT'
}

const observationTypeId = {
  all: 0,
  continenceAssessment: 2
}

const physicalActivityEventType = {
  low: 'LOW',
  medium: 'MEDIUM',
  high: 'HIGH'
}

export {
  smartzEventConst,
  voidConst,
  padCycleStartType,
  padCycleEndType,
  bladderEventType,
  observationTypeId,
  physicalActivityEventType
}
